
// 单选
const danxuan: any = { 'id': '', 'title': '单选标题', 'type': '单选', 'options': ['选项一', '选项二'], 'value': '', "required": false };

const jifendanxuan: any = {
    'id': '',
    'title': '计分单选标题',
    'type': '计分单选',
    'options': [
        { 'name': '选项一', 'score': 1 },
        { 'name': '选项二', 'score': 2 },
        { 'name': '选项三', 'score': 3 },
    ],
    'value': {},
    "required": false
};

const xialadanxuan: any = { 'id': '0102', 'title': '性别', 'type': '下拉单选', 'options': ['男', '女'], 'value': '' };

const jifenxialadanxuan: any = {
    'id': '',
    'title': '不超过20分钟',
    'type': '计分下拉单选',
    'options': [
        { 'name': '从来没有', 'score': 0 },
        { 'name': '有些时候', 'score': 1 },
        { 'name': '经常发生', 'score': 3 },
    ],
    'value': {}
};

// 多选
const duoxuan: any = {
    'id': '', 'title': '多选标题', 'type': '多选',
    'options': ['选项一', '选项二', '选项三', '选项四'], 'value': [],
    "required": false
};

const jifenduoxuan: any = {
    'id': '',
    'title': '计分多选标题',
    'type': '计分多选',
    'options': [
        { 'name': '选项一', 'score': 1 },
        { 'name': '选项二', 'score': 2 },
        { 'name': '选项三', 'score': 3 },
        { 'name': '选项四', 'score': 4 },
    ],
    'value': [],
    "required": false
};

const xialaduoxuan: any = {
    'id': '', 'title': '颈椎主动活动时是否有疼痛', 'type': '下拉多选',
    'options': ['前屈', '后伸', '左侧屈', '右侧屈'], 'value': []
};

const jifenxialaduoxuan: any = {
    'id': '',
    'title': '颈椎主动活动时是否有疼痛',
    'type': '计分下拉多选',
    'options': [
        { 'name': '前屈', 'score': 0 },
        { 'name': '后伸', 'score': 1 },
        { 'name': '左侧屈', 'score': 2 },
        { 'name': '右侧屈', 'score': 3 },
    ],
    'value': []
};

// 文件
const wenjian: any = {
    'id': '',
    'title': '文件',
    'type': '文件',
    'value': [],
    'setting': [
        { 'name': '最多上传', 'value': 9, 'unit': '个' },
        { 'name': '支持格式', 'value': ['doc', 'docx', 'xls', 'xlsx', 'pdf', 'jpg', 'png', 'jpeg', 'gif'] },
    ],
    "required": false
};

// 标题
const biaoti: any = {
    'title': "标签",
    'type': '标签'
};
// 问题组
const wentizu: any = {
    'title': "问题组",
    'type': "问题组"
};
// 固定单位数字
const gudindanweishuzi: any = { 'id': '', 'title': '单位', 'type': '固定单位数字', 'unit': '单位', 'value': '', "required": false };
// 可变单位数字
const kebiandanweishuzi: any = {
    'id': '',
    'title': '单位', 'type': '可变单位数字', 'unit': '', 'value': '',
    'options': ['单位一', '单位二', '单位三', '单位四', '单位五'],
    "required": false
};

// 计分条
const jifentiao: any = {
    'id': '',
    'title': '请根据患者的情况在横线上画一记号，表示疗效的好坏程度。',
    'type': '计分条',
    'value': '',
    'setting': {
        'min': { 'name': '无效', 'score': 0 },
        'max': { 'name': '痊愈', 'score': 100 }
    },
    '备注': '',
    "required": false
};
// 字符串
const zifuchuan: any = {
    'id': '', 'title': '备注', 'type': '字符串', 'value': '',
    "required": false
};
// 文本域
const wenbenyu: any = {
    'id': '', 'title': '备注', 'type': '文本域', 'value': '',
    "required": false
};
// 单个时间
const dangeshijian: any = {
    'id': '', 'title': '就诊时间', 'type': '单个时间', 'value': '', 'format': 'datetime',
    "required": false
};



const defaultList: any = {
    单选题: danxuan,
    多选题: duoxuan,
    文件上传: wenjian,
    标题: biaoti,
    数值题: gudindanweishuzi,
    问题组: wentizu,
    标尺: jifentiao,
    文本题: zifuchuan,
    时间: dangeshijian
};

const labels: any[] = [
    { label: "单选题", content: {}, count: 0 },
    { label: "多选题", content: {}, count: 0 },
    { label: "文件上传", content: {}, count: 0 },
    { label: "标题", content: {}, count: 0 },
    { label: "数值题", content: {}, count: 0 },
    { label: "问题组", content: {}, count: 0 },
    { label: "标尺", content: {}, count: 0 },
    { label: "文本题", content: {}, count: 0 },
    // { label: "音频上传", content: {}, count: 0 },
    { label: "时间", content: {}, count: 0 }
];



export {
    labels, defaultList,
    danxuan, jifendanxuan,
    duoxuan, jifenduoxuan,
    gudindanweishuzi, kebiandanweishuzi,
    zifuchuan, wenbenyu
};

